<template>
<tfoot  v-if="paginator.last_page > 1">
  <tr>
    <th colspan="4">
      <div class="ui right floated pagination menu" style="flex-wrap: wrap; justify-content: center;">
        <router-link v-if="paginator.current_page != 1" :to="{name:linkName, params:{page:paginator.current_page-1}}" class="icon item">
          <i class="left chevron icon"></i>
        </router-link>
        <router-link v-for="(link, index) in paginator.last_page" :to="{name:linkName, params:{page:index+1}}" v-bind:class="{ 'active': paginator.current_page == index+1}" class="item">{{index+1}}</router-link>
        <router-link v-if="paginator.last_page != paginator.current_page" :to="{name:linkName, params:{page:paginator.current_page+1}}" class="icon item">
          <i class="right chevron icon"></i>
        </router-link>
      </div>
    </th>
  </tr>
</tfoot>
</template>

<script>
export default {

  props: ['paginator', 'link-name']
}
</script>


// WEBPACK FOOTER //
// Paginator.vue?56ee1bff